'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOKINGRUSH_CREATEREQUEST_START = exports.BOOKINGRUSH_CREATEREQUEST_START = 'BOOKINGRUSH_CREATEREQUEST_START';
var BOOKINGRUSH_CREATEREQUEST_SUCCESS = exports.BOOKINGRUSH_CREATEREQUEST_SUCCESS = 'BOOKINGRUSH_CREATEREQUEST_SUCCESS';
var BOOKINGRUSH_CREATEREQUEST_FAILURE = exports.BOOKINGRUSH_CREATEREQUEST_FAILURE = 'BOOKINGRUSH_CREATEREQUEST_FAILURE';

var BOOKING_REQUEST_CREATE_START = exports.BOOKING_REQUEST_CREATE_START = 'BOOKING_REQUEST_CREATE_START';
var BOOKING_REQUEST_CREATE_SUCCESS = exports.BOOKING_REQUEST_CREATE_SUCCESS = 'BOOKING_REQUEST_CREATE_SUCCESS';
var BOOKING_REQUEST_CREATE_FAILURE = exports.BOOKING_REQUEST_CREATE_FAILURE = 'BOOKING_REQUEST_CREATE_FAILURE';

var LOAD_BOOKING_AVAILABILITY_START = exports.LOAD_BOOKING_AVAILABILITY_START = 'LOAD_BOOKING_AVAILABILITY_START';
var LOAD_BOOKING_AVAILABILITY_SUCCESS = exports.LOAD_BOOKING_AVAILABILITY_SUCCESS = 'LOAD_BOOKING_AVAILABILITY_SUCCESS';
var LOAD_BOOKING_AVAILABILITY_FAILURE = exports.LOAD_BOOKING_AVAILABILITY_FAILURE = 'LOAD_BOOKING_AVAILABILITY_FAILURE';

var BOOKINGRUSH_CREATE_START = exports.BOOKINGRUSH_CREATE_START = 'BOOKINGRUSH_CREATE_START';
var BOOKINGRUSH_CREATE_SUCCESS = exports.BOOKINGRUSH_CREATE_SUCCESS = 'BOOKINGRUSH_CREATE_SUCCESS';
var BOOKINGRUSH_CREATE_FAILURE = exports.BOOKINGRUSH_CREATE_FAILURE = 'BOOKINGRUSH_CREATE_FAILURE';

var BOOKINGRUSH_UPDATE_START = exports.BOOKINGRUSH_UPDATE_START = 'BOOKINGRUSH_UPDATE_START';
var BOOKINGRUSH_UPDATE_SUCCESS = exports.BOOKINGRUSH_UPDATE_SUCCESS = 'BOOKINGRUSH_UPDATE_SUCCESS';
var BOOKINGRUSH_UPDATE_FAILURE = exports.BOOKINGRUSH_UPDATE_FAILURE = 'BOOKINGRUSH_UPDATE_FAILURE';

var LOYALTYCARD_ADDSTAMPS_START = exports.LOYALTYCARD_ADDSTAMPS_START = 'LOYALTYCARD_ADDSTAMPS_START';
var LOYALTYCARD_ADDSTAMPS_SUCCESS = exports.LOYALTYCARD_ADDSTAMPS_SUCCESS = 'LOYALTYCARD_ADDSTAMPS_SUCCESS';
var LOYALTYCARD_ADDSTAMPS_FAILURE = exports.LOYALTYCARD_ADDSTAMPS_FAILURE = 'LOYALTYCARD_ADDSTAMPS_FAILURE';

var LOYALTYCARD_GET_ACTIVE_CARD_START = exports.LOYALTYCARD_GET_ACTIVE_CARD_START = 'LOYALTYCARD_GET_ACTIVE_CARD_START';
var LOYALTYCARD_GET_ACTIVE_CARD_SUCCESS = exports.LOYALTYCARD_GET_ACTIVE_CARD_SUCCESS = 'LOYALTYCARD_GET_ACTIVE_CARD_SUCCESS';
var LOYALTYCARD_GET_ACTIVE_CARD_FAILURE = exports.LOYALTYCARD_GET_ACTIVE_CARD_FAILURE = 'LOYALTYCARD_GET_ACTIVE_CARD_FAILURE';

var LOYALTYCARD_GET_CARD_START = exports.LOYALTYCARD_GET_CARD_START = 'LOYALTYCARD_GET_CARD_START';
var LOYALTYCARD_GET_CARD_SUCCESS = exports.LOYALTYCARD_GET_CARD_SUCCESS = 'LOYALTYCARD_GET_CARD_SUCCESS';
var LOYALTYCARD_GET_CARD_FAILURE = exports.LOYALTYCARD_GET_CARD_FAILURE = 'LOYALTYCARD_GET_CARD_FAILURE';

var USER_AUTHENTICATE_START = exports.USER_AUTHENTICATE_START = 'USER_AUTHENTICATE_START';
var USER_AUTHENTICATE_SUCCESS = exports.USER_AUTHENTICATE_SUCCESS = 'USER_AUTHENTICATE_SUCCESS';
var USER_AUTHENTICATE_FAILURE = exports.USER_AUTHENTICATE_FAILURE = 'USER_AUTHENTICATE_FAILURE';

var USER_REGISTER_START = exports.USER_REGISTER_START = 'USER_REGISTER_START';
var USER_REGISTER_SUCCESS = exports.USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
var USER_REGISTER_FAILURE = exports.USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';

var USER_LOGOUT_START = exports.USER_LOGOUT_START = 'USER_LOGOUT_START';
var USER_LOGOUT_SUCCESS = exports.USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
var USER_LOGOUT_FAILURE = exports.USER_LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE';

var USER_UPDATE_ACCESSTOKEN = exports.USER_UPDATE_ACCESSTOKEN = 'USER_UPDATE_ACCESSTOKEN';

var USER_LOAD_START = exports.USER_LOAD_START = 'USER_LOAD_START';
var USER_LOAD_SUCCESS = exports.USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS';
var USER_LOAD_FAILURE = exports.USER_LOAD_FAILURE = 'USER_LOAD_FAILURE';
var USER_LOAD_CREDIT_CARDS_SUCCESS = exports.USER_LOAD_CREDIT_CARDS_SUCCESS = 'USER_LOAD_CREDIT_CARDS_SUCCESS';
var USER_DELETE_CREDIT_CARD_SUCCESS = exports.USER_DELETE_CREDIT_CARD_SUCCESS = 'USER_DELETE_CREDIT_CARD_SUCCESS';
var USER_ADD_TMP_NEW_CREDIT_CARD = exports.USER_ADD_TMP_NEW_CREDIT_CARD = 'USER_ADD_TMP_NEW_CREDIT_CARD';

var USER_LOAD_ORDERS_START = exports.USER_LOAD_ORDERS_START = 'USER_LOAD_ORDERS_START';
var USER_LOAD_ORDERS_SUCCESS = exports.USER_LOAD_ORDERS_SUCCESS = 'USER_LOAD_ORDERS_SUCCESS';
var USER_LOAD_ORDERS_FAILURE = exports.USER_LOAD_ORDERS_FAILURE = 'USER_LOAD_ORDERS_FAILURE';

var USER_RESET_ORDERS = exports.USER_RESET_ORDERS = 'USER_RESET_ORDERS';

var USER_LOAD_BOOKING_REQUESTS_START = exports.USER_LOAD_BOOKING_REQUESTS_START = 'USER_LOAD_BOOKING_REQUESTS_START';
var USER_LOAD_BOOKING_REQUESTS_SUCCESS = exports.USER_LOAD_BOOKING_REQUESTS_SUCCESS = 'USER_LOAD_BOOKING_REQUESTS_SUCCESS';
var USER_LOAD_BOOKING_REQUESTS_FAILURE = exports.USER_LOAD_BOOKING_REQUESTS_FAILURE = 'USER_LOAD_BOOKING_REQUESTS_FAILURE';

var USER_SELECT_ARCHIVED_ORDER = exports.USER_SELECT_ARCHIVED_ORDER = 'USER_SELECT_ARCHIVED_ORDER';

var VOUCHER_REDEEM_START = exports.VOUCHER_REDEEM_START = 'VOUCHER_REDEEM_START';
var VOUCHER_REDEEM_SUCCESS = exports.VOUCHER_REDEEM_SUCCESS = 'VOUCHER_REDEEM_SUCCESS';
var VOUCHER_REDEEM_FAILURE = exports.VOUCHER_REDEEM_FAILURE = 'VOUCHER_REDEEM_FAILURE';

var VOUCHER_GET_MINE_START = exports.VOUCHER_GET_MINE_START = 'VOUCHER_GET_MINE_START';
var VOUCHER_GET_MINE_SUCCESS = exports.VOUCHER_GET_MINE_SUCCESS = 'VOUCHER_GET_MINE_SUCCESS';
var VOUCHER_GET_MINE_FAILURE = exports.VOUCHER_GET_MINE_FAILURE = 'VOUCHER_GET_MINE_FAILURE';

var VOUCHER_CREATE_START = exports.VOUCHER_CREATE_START = 'VOUCHER_CREATE_START';
var VOUCHER_CREATE_SUCCESS = exports.VOUCHER_CREATE_SUCCESS = 'VOUCHER_CREATE_SUCCESS';
var VOUCHER_CREATE_FAILURE = exports.VOUCHER_CREATE_FAILURE = 'VOUCHER_CREATE_FAILURE';

var VOUCHER_FORMAT_PERCENTAGE = exports.VOUCHER_FORMAT_PERCENTAGE = 'PERCENTAGE';
var VOUCHER_FORMAT_ABSOLUTE = exports.VOUCHER_FORMAT_ABSOLUTE = 'ABSOLUTE_VALUE';
var VOUCHER_FORMAT_FREE_ITEM = exports.VOUCHER_FORMAT_FREE_ITEM = 'FREE_ITEM';

var VOUCHER_UPDATE_START = exports.VOUCHER_UPDATE_START = 'VOUCHER_UPDATE_START';
var VOUCHER_UPDATE_SUCCESS = exports.VOUCHER_UPDATE_SUCCESS = 'VOUCHER_UPDATE_SUCCESS';
var VOUCHER_UPDATE_FAILURE = exports.VOUCHER_UPDATE_FAILURE = 'VOUCHER_UPDATE_FAILURE';

var GLOBAL_APP_INIT = exports.GLOBAL_APP_INIT = 'GLOBAL_APP_INIT';

var GLOBAL_ERRORS_SET = exports.GLOBAL_ERRORS_SET = 'GLOBAL_ERRORS_SET';
var GLOBAL_ERRORS_CLEAR = exports.GLOBAL_ERRORS_CLEAR = 'GLOBAL_ERRORS_CLEAR';

var GLOBAL_SUCCESS_SET = exports.GLOBAL_SUCCESS_SET = 'GLOBAL_SUCCESS_SET';
var GLOBAL_SUCCESS_CLEAR = exports.GLOBAL_SUCCESS_CLEAR = 'GLOBAL_SUCCESS_CLEAR';

var GLOBAL_MESSAGE_SHOW = exports.GLOBAL_MESSAGE_SHOW = 'GLOBAL_MESSAGE_SHOW';

var CONNECTIVITY_ERROR = exports.CONNECTIVITY_ERROR = 'CONNECTIVITY_ERROR';

var EXTRA_COST_TYPE_POSITIVE = exports.EXTRA_COST_TYPE_POSITIVE = 'positive';
var EXTRA_COST_TYPE_NEGATIVE = exports.EXTRA_COST_TYPE_NEGATIVE = 'negative';
var EXTRA_COST_TYPE_NEUTRAL = exports.EXTRA_COST_TYPE_NEUTRAL = 'neutral';

var RESTAURANTS_REFRESH_START = exports.RESTAURANTS_REFRESH_START = 'RESTAURANTS_REFRESH_START';
var RESTAURANTS_REFRESH_SUCCESS = exports.RESTAURANTS_REFRESH_SUCCESS = 'RESTAURANTS_REFRESH_SUCCESS';
var RESTAURANTS_REFRESH_FAILURE = exports.RESTAURANTS_REFRESH_FAILURE = 'RESTAURANTS_REFRESH_FAILURE';

var ORDER_STATUS_CONFIRMED = exports.ORDER_STATUS_CONFIRMED = 'CONFIRMED';
var ORDER_STATUS_PENDING = exports.ORDER_STATUS_PENDING = 'PENDING';
var ORDER_STATUS_DECLINED = exports.ORDER_STATUS_DECLINED = 'DECLINED';

var SWITCH_BUNDLE_ID = exports.SWITCH_BUNDLE_ID = 'SWITCH_BUNDLE_ID';


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/~/@arreeba/ristoranti-lib/lib/constants.js
// module id = 24
// module chunks = 0